import React from 'react';
import PropTypes from 'prop-types';

const InputToggleButton = ({ name, label, style, checked, onClick }) => {
  const classes = ['input-toggle-button'];
  const disabled = !onClick;

  if (checked) {
    classes.push('input-toggle-button--checked');
  }

  if (style) {
    classes.push(`input-toggle-button--${style}`);
  }

  return (
    <button className={classes.join(' ')} type="button" name={name} key={name} onClick={onClick} disabled={disabled}>
      {label}
    </button>
  );
};

export default InputToggleButton;
